import { GameMode } from '@core/common';

export const LIVE_DROP_GAMES_IMG: Record<GameMode, string> = {
  crash: 'assets/images/navbar/crash.webp',
  wheel: 'assets/images/navbar/wheel.webp',
  super_wheel: 'assets/images/navbar/super_wheel.webp',
  double: 'assets/images/navbar/double.webp',
  defuse: 'assets/images/navbar/defuse.webp',
  mines: 'assets/images/navbar/mines.webp',
  jackpot: 'assets/images/navbar/jackpot.webp',
  battleship: 'assets/images/navbar/battleship.webp',
  'lucky-drop': 'assets/images/navbar/lucky-drop.webp'
};
